module.exports = __webpack_public_path__ + "img/prize_1_hasud.85a3458b.jpg";